module.exports = __webpack_public_path__ + "static/img/06.e5c243e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/03/06.jpg
// module id = 3uL3
// module chunks = 0